import { Actions } from 'vuex-smart-module';
import { Filters } from '@/types';
import { WidgetsService } from '../services';
import WidgetsState from './state';
import WidgetsMutations from './mutations';
import WidgetsGetters from './getters';

const widgetsService = new WidgetsService();

export default class WidgetsActions extends Actions<
  WidgetsState,
  WidgetsGetters,
  WidgetsMutations,
  WidgetsActions
> {
  async get_widgets() {
    try {
      const { data } = await widgetsService.get_widgets();

      this.mutations.SET_WIDGETS(data.items);
    } catch (error) {
      console.log(error);
    }
  }

  async get_filtered_widget(section: string) {
    try {
      const payload: Filters = {
        filters: this.state.filters,
      };

      const { data } = await widgetsService.get_filtered_widget(payload, section);

      const { items } = data;
      const sections: (keyof typeof items)[] = ['retro_bonuses'];

      sections.forEach((key) => {
        if (items[key] !== undefined && items[key] !== null) {
          this.mutations.SET_RESPONSE_WIDGETS(items[key] as unknown);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
}
